module.exports = __webpack_public_path__ + "static/media/s_pro10.ae2340e3.gif";